module.exports = __webpack_public_path__ + "img/812.be5176f0.png";